import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfSwiperTab, { EfSwiperTabItemProps, EfSwiperTabProps } from '@elem/ui/ef-swiper-tab';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');
    const lists: EfSwiperTabItemProps[] = [
        {
            isVideo: true,
            poster: 'https://websiteoss.ecoflow.com/upload/image/1721114961777/img_PowerTrail.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/video/1721110183399/%E6%8B%96%E6%8C%82940X440.mp4',
            tab: t('C_tab1'),
            desc: t('C_tab1_desc'),
        },
        {
            isVideo: true,
            poster: 'https://websiteoss.ecoflow.com/upload/image/1721114974696/img_PowerLuxe.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/video/1721110358634/A%E7%BA%A7940X440.mp4',
            tab: t('C_tab2'),
            desc: t('C_tab2_desc'),
        },
        {
            isVideo: true,
            poster: 'https://websiteoss.ecoflow.com/upload/image/1721114986849/img_PowerSwift.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/video/1721110409276/B%E7%BA%A7940X440.mp4',
            tab: t('C_tab3'),
            desc: t('C_tab3_desc'),
        },
    ];

    const configs: EfSwiperTabProps = {
        theme: 'black',
        navigation: false,
        loop: false,
        initialSlide: 1,
        title: t('C_title'),
        lists,
    };

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec" />
            <EfSection theme="white" title={t('C_title')} desc={t('C_desc')} />
            <EfSwiperTab {...configs} />
            <EfSpec className="spec" />
        </div>
    );
}
